import { useState, useCallback } from 'react';

/**
 * Anti-spam hook for forms.
 * Returns hidden fields (honeypot + timestamp) to include in form submissions.
 * Backend rejects submissions where honeypot is filled or timing is too fast.
 * Combined with backend rate limiting for robust spam protection.
 */
export function useAntiSpam() {
  const [loadedAt] = useState(() => (Date.now() / 1000).toString());
  const [honeypot, setHoneypot] = useState('');

  return {
    // Spread these into your JSON body before submitting
    antiSpamFields: {
      website: honeypot,           // honeypot field
      _loaded: loadedAt,           // timing check
    },
    // Render this inside your form (invisible honeypot only — no visible CAPTCHA)
    AntiSpamFields: () => (
      <div style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, overflow: 'hidden' }} aria-hidden="true" tabIndex={-1}>
        <label htmlFor="website_url">Website</label>
        <input
          type="text"
          id="website_url"
          name="website"
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
          autoComplete="off"
          tabIndex={-1}
        />
      </div>
    ),
  };
}
